import React from 'react';
import { useNavigate } from 'react-router-dom';
import { fmtDate } from '../../utils/helpers';

export default function DashboardDesktop({ vm }) {
  const { event, cards, guestSide, setGuestSide, isMarriage } = vm;
  const navigate = useNavigate();
  return (
    <div>
      <div className="page-head">
        <h1>Dashboard</h1>
        <div className="spacer" />
        <span className="muted">{event?.EventName || 'Select event'}</span>
      </div>

      {event && isMarriage && (
        <div className="side-toggle" style={{ maxWidth: 300 }}>
          <div className={`side-toggle-slider ${guestSide.toLowerCase()}`} />
          <button
            className={`side-toggle-btn ${guestSide === 'Groom' ? 'active' : ''}`}
            onClick={() => setGuestSide('Groom')}
          >
            Groom Side
          </button>
          <button
            className={`side-toggle-btn ${guestSide === 'Bride' ? 'active' : ''}`}
            onClick={() => setGuestSide('Bride')}
          >
            Bride Side
          </button>
        </div>
      )}

      <div className="grid kpi" style={{ marginBottom: 18 }}>
        {cards.map((card, index) => (
          <button
            key={index}
            type="button"
            className="kpi-card kpi-link"
            style={{ background: card.g }}
            onClick={() => card.to && navigate(card.to)}
          >
            <div className="n">{card.n}</div>
            <div className="l">{card.l}</div>
          </button>
        ))}
      </div>

      {event && (
        <div className="card" style={{ marginTop: 16 }}>
          <div className="card-pad">
            <strong>{event.EventName}</strong>
            <div className="muted" style={{ marginTop: 4, fontSize: 13 }}>
              {event.EventTypeName || event.EventType} | {fmtDate(event.EventStartDate)} to {fmtDate(event.EventEndDate)} | {event.Venue || ''} {event.City || ''}
            </div>
            {isMarriage && (
              <div style={{ marginTop: 8, fontSize: 13 }}>
                <span className="chip male" style={{ marginRight: 8 }}>Groom: {event.MaleSideName || '-'}</span>
                <span className="chip female">Bride: {event.FemaleSideName || '-'}</span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
